import { AxiosPromise } from 'axios'
import client from '@/shared/apis/client'
import type { PatientAttributesResponse } from '../types'

// 来局の患者の属性 7 つ (会話・頭書き・なし の行).
// back: GET /api/patient-attributes/events/<event_id>/
// 他の薬局の来局は 404. 患者につながらない来局は status: 'patient_not_linked'.
export const getPatientAttributes = (
  yakurekiId: string
): AxiosPromise<PatientAttributesResponse> => {
  return client.get(`/api/patient-attributes/events/${yakurekiId}/`)
}
